import { useEffect } from 'react';

import { useFocusModeStore } from '@/shared/store/focusMode';
import { usePreferencesStore } from '@/shared/store/preferences';

/** Ask the shell for the whole width while this page is shown (spec 128 R4). */
export function useFocusMode(): void {
  const enter = useFocusModeStore((state) => state.enter);
  const leave = useFocusModeStore((state) => state.leave);
  useEffect(() => {
    enter();
    return leave;
  }, [enter, leave]);
}

/** Note that this device opened a workflow, for the sidebar's recents (spec 128 R3). */
export function useRememberWorkflow(
  workspaceId: string,
  workflowKey: string,
): void {
  const remember = usePreferencesStore((state) => state.rememberWorkflow);
  useEffect(() => {
    remember(workspaceId, workflowKey);
  }, [remember, workspaceId, workflowKey]);
}
